import './ccf-phone-outbound-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPhoneOutboundIconProps extends SvgIconProps  {}

/**
 * CcfPhoneOutboundIcon used to disply phone outbound icon in the contact card channel panel
 * @param props - CcfPhoneOutboundIconProps
 * @example -- <CcfPhoneOutboundIcon />
 */
export function CcfPhoneOutboundIcon(props: CcfPhoneOutboundIconProps) {
  return (
    <SvgIcon viewBox="0 0 14.615 15.1" {...props}>
      <g transform="translate(0 -0.9)"><path className="a" d="M9.239-32.21s-.643,1.039-.7,1.127-.184.349-.783.173a8.693,8.693,0,0,1-3.548-2.559A9.024,9.024,0,0,1,1.73-37.134c-.171-.619.082-.747.167-.809s1.091-.726,1.091-.726c.677-.41-.089-2.163-1.323-3.007C.754-42.3.354-42.238-.029-41.931A9.859,9.859,0,0,0-1.69-40.172a1.714,1.714,0,0,0-.291,1.2A10.254,10.254,0,0,0-.623-35.2a18.071,18.071,0,0,0,2.861,3.76,17.711,17.711,0,0,0,3.639,2.956,9.511,9.511,0,0,0,3.655,1.4,1.584,1.584,0,0,0,1.162-.3,9.838,9.838,0,0,0,1.7-1.717c.3-.4.355-.808-.248-1.75C11.333-32.119,9.636-32.909,9.239-32.21Z" transform="translate(2 43.056)"/></g>
    </SvgIcon>
  );
}

export default CcfPhoneOutboundIcon;
